@import 'vars';

$border-width: 10px;
$left-border-width: 3px;
$padding-left: $padding-medium - $left-border-width;

.info-panel {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  border-left: $left-border-width solid transparent;
  min-height: fit-content;

  &__inner {
    display: flex;
    align-items: stretch;
    padding: $padding-medium $padding-medium $padding-medium $padding-left;

    &__icon {
      max-height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: $margin-xsmall;
      justify-content: center;

      &--with-title {
        justify-content: flex-start;
        margin-top: 3px;
      }

      &--small {
        margin-right: 10px;
      }
    }

    &--no-stroke {
      padding-left: 0;
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    &__header {
      display: flex;
      align-items: center;
    }
  }

  &__arrow {
    width: 0 !important;
    height: 0 !important;
    border-left: $border-width solid transparent !important;
    border-right: $border-width solid transparent !important;
    border-top: $border-width solid;
    margin-left: auto;
    margin-right: 50px;
  }
}
